<template>
  <!--查看-->
  <div>
    <el-form :model="formData" :rules="rules" v-loading="saveLoading" ref="editForm" size="small" :label-width="'160px'" class="form-horizontal detail-form paddingTopDetail employeeEditDetail" >
      <el-form-item prop="type" label="监控类型：" class="rowItem">
        <el-select v-model="formData.type" filterable  placeholder="请选择" class="m-r-md" popper-class="edit-sel-popper" :disabled="detailType=='edit'" style="z-index: 8888 !important;">
          <el-option v-for="item in selOptions.monitor_type" :key="item.name" :label="item.value" :value="item.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="expTimingInterval" label="定时接口调用间隔：" >
        <div class="flex-row">
          <el-input v-model.number="formData.expTimingInterval" placeholder="请输入"  style="flex: 1;"></el-input>
          <div style="width: 40px;">&nbsp;&nbsp;分钟</div>
        </div>
      </el-form-item>
      <el-form-item  prop="expPushInterval" label="异常推送间隔："  >
        <div class="flex-row">
          <el-input v-model.number="formData.expPushInterval" placeholder="请输入"  style="flex: 1;"></el-input>
          <div style="width: 40px;">&nbsp;&nbsp;分钟</div>
        </div>
      </el-form-item>
      <el-form-item label="异常推送手机：" v-for='(item, index) in formData.noticePhoneArr' :key="'mo6pppe_'+index" :prop="'noticePhoneArr.'+index+'.value'"  :rules="rules.telephone" class="is-required">
        <div class="itemWithIcon">
          <el-input  v-model="item.value" placeholder="请输入"   ></el-input>
          <a @click="addFormItem('noticePhone')"  class="m-l-sm m-b-26" v-if="index==(formData.noticePhoneArr.length-1)">
            <i class="iconfontpage icon-r-add-more icon-default-color" ></i>
          </a>
        </div>
      </el-form-item>
      <el-form-item label="异常推送邮箱：" v-for='(item, index) in formData.noticeMailArr' :key="'momaile_'+index" :prop="'noticeMailArr.'+index+'.value'" :rules="rules.email" class="is-required">
        <div class="itemWithIcon">
          <el-input  v-model="item.value" placeholder="请输入"   ></el-input>
          <a @click="addFormItem('noticeMail')"  class="m-l-sm m-b-26" v-if="index==(formData.noticeMailArr.length-1)">
            <i class="iconfontpage icon-r-add-more icon-default-color" ></i>
          </a>
        </div>
      </el-form-item>
      <el-form-item  prop="expand" label="推送模板："  >
        {{'[监控类型]年-月-日 时:分:秒发生异常！'}}
      </el-form-item>
      <div style="text-align: center;padding: 20px;width: 100%;">
        <el-button class="primary-btn-g" icon="CircleCheck" @click="handleSave(0)" >保存</el-button>
        <el-button class="warning-btn-g" icon="CircleClose" @click="handleCancel">取消</el-button>
      </div>

    </el-form>
  </div>
</template>

<script>
  import RichText from "@/components/common/RichText/RichText";
  import {
    mapActions
  } from 'vuex'
  import formCheck from '@/components/common/formCheck'
  export default {
    components: {RichText},
    mixins: [ formCheck],
    name: "pushDetailModel",
      props:{
        selOptions: {
          type: Object,
          default:{monitor_type:[]},
        },
        selOptionMaps:{
          type: Object,
          default:{monitor_type:{}}
        },
        detailModal:{
          type:Boolean,
          default:''
        },
        detailData:{
          type:Object,
          default:{}
        },
        detailType:{
          type:String,
          default:'show'
        }
      },
      data(){
        let detailKeys = ['type','phone','email','expPushInterval','expTimingInterval']
        let formData = {}
        detailKeys.map((key)=>{
          formData[key] = ''
        })
        formData['noticePhoneArr'] = [{value:''}]
        formData['noticeMailArr'] = [{value:''}]

        let validateIP = (rule, value, callback) => {
          if (!this.checkIPAddress(value)) {
            callback(new Error('IP格式错误'));
          } else {
            callback();
          }
        };

        return{
          isValid:true,
          activeNames: ['1','2','3','4','5','6','7'],
          showType:'',
          saveLoading:false,
          detailKeys:detailKeys,

          rules:{
            /*'type','phone','email','expPushInterval','expTimingInterval'*/
            type:[{ required: true, message: '请选择', trigger: 'blur' }],
            expPushInterval:[{ required: true, message: '请输入', trigger: 'blur' },{ validator: this.validateNum, trigger: 'blur' ,message: '必须为大于0的数字值'}],
            expTimingInterval:[{ required: true, message: '请输入', trigger: 'blur' },{ validator: this.validateNum, trigger: 'blur' ,message: '必须为大于0的数字值'}],
            telephone:[{validator: this.checkTel, trigger: 'blur',message:'格式输入有误'}],
            email:[{pattern:/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/, trigger: 'blur',message:'格式输入有误'}],
          },
          region_provinceDicts:[],
          region_cityDicts:[],
          region_areaDicts:[],
          formData:formData
        }
    },
    created(){
    },
    mounted(){
      this.showType = this.detailType
    },
    watch:{
      detailType(val){
        this.showType = val
      },
      detailModal:{
        immediate: true,
        handler: function(to){
          if(to===false){
            return false
          }
          this.$nextTick(()=>{
            this.$refs.editForm.resetFields()
            this.initFormData()
          })
        }
      }
    },
    methods:{
      ...mapActions([
        'alertToggle',
        'fetchData'
      ]),
      initFormData(){
        if(this.detailType=='add'){
          this.detailKeys.map((key)=>{
            this.formData[key] = ''
          })
          this.formData['noticePhoneArr'] = [{value:''}]
          this.formData['noticeMailArr'] = [{value:''}]
        }
        if(this.detailType=='edit'){
          this.detailKeys.map((key)=>{
            this.formData[key] = this.detailData[key] ? this.detailData[key]:''
          })

          let mails = this.detailData.email ? this.detailData.email.split(','):[]
          let phones = this.detailData.phone ? this.detailData.phone.split(','):[]

          let tmpMails = []
          let tmpPhones = []
          mails.length && mails.map((item)=>{
            tmpMails.push({value:item})
          })
          phones.length && phones.map((item)=>{
            tmpPhones.push({value:item})
          })

          this.formData['noticePhoneArr'] = tmpPhones.length ? tmpPhones:[{value:''}]
          this.formData['noticeMailArr'] = tmpMails.length ? tmpMails:[{value:''}]

        }
      },
      addFormItem(type){
        this.formData[type+'Arr'].push({value:''})
      },
      //保存
      handleSave(type){
        this.saveLoading = true
        this.trimFormData()
        this.$refs['editForm'].validate((valid) => {
          if (valid && this.isValid) {
            this.doSave(type)
          } else {
            //this.$message.error('输入不合法！')
            this.saveLoading = false
            return false;
          }
        });
      },
      doSave(type){

        let url = 'SAAS.DATAPUSH_ALARM_SAVE'
        let paramData = {...this.formData}

        if(this.detailType=='add'){
          delete paramData.id
        }else{
          paramData.id = this.detailData.id
        }

        let phoneStrs = []
        if(this.formData.noticePhoneArr.length){
          this.formData.noticePhoneArr.map((item)=>{
            item.value.trim()!=='' && phoneStrs.push(item.value.trim())
          })
        }

        let mailStrs = []
        if(this.formData.noticeMailArr.length){
          this.formData.noticeMailArr.map((item)=>{
            item.value.trim()!=='' && mailStrs.push(item.value.trim())
          })
        }

        if(!phoneStrs.length){
          this.$message.error('请输入异常推送手机！')
          this.saveLoading = false
          return false;
        }
        if(!mailStrs.length){
          this.$message.error('请输入异常推送邮箱！')
          this.saveLoading = false
          return false;
        }

        paramData.email = mailStrs.join(',')
        paramData.phone = phoneStrs.join(',')
        paramData.typeName = this.selOptionMaps['monitor_type'][paramData.type] ? this.selOptionMaps['monitor_type'][paramData.type]:paramData.type
        delete paramData.noticePhoneArr
        delete paramData.noticeMailArr

        /*paramData = { "type": "10004",   "typeName": "2222",   "phone": "demoData",   "email": "demoData",  "expPushInterval": 10,   "expTimingInterval": 10 }
        * {"type":"10004","phone":"15689652386","email":"dsfsd@fdsaf.com","expPushInterval":1,"expTimingInterval":1,"id":1,"typeName":"ddddde"}
        * */
       // paramData = {"type":"10004","phone":"demoData","email":"demoData","expPushInterval":10,"expTimingInterval":10,"typeName":"ddd2dde"}

        let params = {params:JSON.stringify(paramData)}

        this.fetchData({url:url, method: 'post', params:params,timeout:0, isLoading:false, flag:true}).then((res)=>{
          if(res.status==1){
            this.$message.success('操作成功！')
            this.$emit('submitSuccess')
          }else{
            this.$message.error(res.msg||'操作失败！')
          }
          this.saveLoading = false
        }).catch((err)=>{
          if(typeof err === 'string'){
            this.$message.error(err)
          }else{
            this.$message.error('操作失败！')
          }

          this.saveLoading = false
        }).finally (()=>{
          this.saveLoading = false
        })
      },
      handleCancel(){
        this.$emit('closeModel')
      },
    },
  }
</script>

<style lang="less" scoped>
  .employeeEditDetail{
    display: flex;
    flex-wrap: wrap;
    margin: 0 auto;
    width: 90% !important;
  }
  .employeeEditDetail .el-form-item{
    width: 50% !important;
    .el-select{
      width: 100%;
    }
  }
  .employeeEditDetail .el-form-item.rowItem {
    width: 100% !important;
  }
  .employeeEditDetail .detailContent{
    padding: 0px;
  }
  .sentContent{
    margin: 20px;
    padding: 10px;
    border: 1px solid rgba(38, 118, 165, 1) ;
  }
  .sentContentTitle{
    text-align: center;
  }
  .itemWithIcon{
    width: 100%;
    display: flex;
  }
  .icon-default-color{
    color:rgba(0, 0, 0, 0.68);
  }


</style>
<style lang="less" >
  .employeeEditDetail .w-e-text-container{
    border:1px solid #2676a5 !important;
  }
</style>

